import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useLang } from '@/hooks/useLang';

export default function PrivacyPage() {
  const lang = useLang();

  useEffect(() => {
    document.title = 'Privacy Policy | AllChinaBuy Spreadsheet Hub';
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <div className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-16">
          <div className="max-w-3xl mx-auto">
            <h1 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-6">Privacy Policy</h1>
            <div className="prose max-w-none text-foreground-700 leading-relaxed space-y-4">
              <p><strong>Last Updated:</strong> August 26, 2026</p>
              <p>
                At AllChinaBuy Spreadsheet Hub, we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you visit our website.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">Information We Collect</h2>
              <p>
                We may collect limited information when you visit our website, including your IP address, browser type, device information, and pages visited. This information is used for analytics and improving our website experience. We do not collect personal information unless you voluntarily provide it through our contact form.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">How We Use Your Information</h2>
              <p>
                We use collected information to improve our website, understand user preferences, and respond to inquiries. We do not sell, rent, or share your personal information with third parties for marketing purposes.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">Cookies</h2>
              <p>
                We may use cookies and similar technologies to enhance your browsing experience. You can control cookie preferences through your browser settings. Disabling cookies may affect certain website features.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">Third-Party Links</h2>
              <p>
                Our website contains links to third-party websites, including our main website at kaspreadsheet.com. We are not responsible for the privacy practices or content of these external sites. We encourage you to review their privacy policies before providing any personal information.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">Data Security</h2>
              <p>
                We implement reasonable security measures to protect your information. However, no method of transmission over the internet is 100% secure. We cannot guarantee absolute security of your data.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. Changes will be posted on this page with the updated date. We encourage you to review this policy periodically.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">Contact Us</h2>
              <p>
                If you have questions about this Privacy Policy, please contact us through our <a href={`/${lang}/contact/`} className="text-primary-600 hover:text-primary-700">Contact page</a>.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}